import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup} from '@angular/forms';
import {ActivatedRoute, NavigationEnd, Router} from '@angular/router';
import moment from 'moment';
import {SharedModule} from "../../../../../../shared/shared.module";
import {NgxIntlTelInputModule} from "@justin-s/ngx-intl-tel-input";
import {CandidatesApplied, Mission} from "../../../../../../models/Mission";
import {Candidat} from "../../../../../../models/Candidat";
import {AlertDialogService} from "../../../../../../services/alert-dialog.service";
import {MissionService} from "../../../../../../services/mission.service";
import {CandidatService} from "../../../../../../services/candidat.service";
import {AuthService} from "../../../../../../services/auth.service";
import {FlagService} from "../../../../../../shared/services/flag.service";
import {MatDialog} from "@angular/material/dialog";
import {DetailsComponent} from "../../../../../../pages/etablissement/candidatures/details/details.component";
import {calculDiffDays} from "../../../../../../shared/utils/utils.functions";
import {CandidatStatusOnMission, FlagType, MissionStatusEnum} from "../../../../../../shared/utils/enums";
import {DatePipe} from "@angular/common";

@Component({
  selector: 'app-mission-validation',
  templateUrl: './mission-validation.component.html',
  standalone: true,
  imports: [
    SharedModule,
    NgxIntlTelInputModule,
    DatePipe
  ],
  styleUrl: './mission-validation.component.scss'
})
export class MissionValidationComponent implements OnInit {
  baseUrl = ''
  isClosed : boolean = false
  missionId: string;
  form : FormGroup = this.fb.group({
    candidatFullname: [''],
    enddate: [''],
    startdate: [''],
    candidatId: [''],
    etablissementId: [''],
    serviceAffectation: [''],
    id: [''],
    missionStatus: [''],
    rating: 0,
    comment : ['']
  })
  listUrls : any = {
    path: 'missions',
    label : 'Missions',
    url: '/dashboard/missions',
    children: [
      {
        path: "validation",
        label:'Validation',
        url: '/dashboard/missions/validation/',
      },
    ]
  }

  mission: Mission;
  candidatApplied: CandidatesApplied;
  candidat: Candidat;
  skillsRate = 0;
  connectionMemberRate = 0;
  connectionClientRate = 0;
  punctualityRate = 0;
  constructor(private fb : FormBuilder,
              private router : Router,
              private alertDialogService : AlertDialogService,
              private missionService: MissionService,
              private candidatService: CandidatService,
              private auth: AuthService,
              private flag: FlagService,
              private route: ActivatedRoute, private dialog: MatDialog ){
    this.baseUrl = this.router.url
    this.missionId = this.route.snapshot.params['id'];
    this.listUrls.children[0].url = this.listUrls.children[0].url + this.missionId;

  }
  ngOnInit(): void {
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.
    this.router.events.subscribe((event) => {
      if(this.baseUrl.includes('validation') && !this.isClosed) {
        if (event instanceof NavigationEnd) {
          // We've finished navigating
          if(!event.urlAfterRedirects.includes('validation')) {
            this.alertDialogService
            ?.openAlertModal(
              'success',
              'Quitter sans envoyer le feedback ?',
              'Êtes-vous sûr de vouloir quitter cette page sans envoyer votre feedback ? Vos commentaires peuvent nous aider à améliorer notre service. ',
              'Quitter sans envoyer',
              'Rester',
              '462px',
              false

            )
            ?.subscribe((res: any) => {
              if (!res) {
                this.alertDialogService.closeAlertModal(1)
                this.baseUrl = ''
               this.router.navigateByUrl(`/dashboard/missions/validation/${this.missionId}`)
                this.isClosed = false;
              }else{
                this.isClosed = true
              }
            });
          }
        }
      }


    });
    this.getMissionById();
  }

    openDetailCandidate = (id: any) => {
    this.dialog.open(DetailsComponent, {
      width: '666px',
      height: '100vh',
      position: { right: '0' },
      backdropClass: 'bg-transparent',
      data: {
        candidature: {candidatId: id}
      }
    });
  };
  getMissionById() {
    this.missionService.getMissionById(this.missionId).subscribe({
      next: (value: any) => {
        this.mission = value;
        this.candidatApplied = this.mission.candidatesApplied.
          find((a: { statusOfCandidatOnMission: any; }) => a.statusOfCandidatOnMission === CandidatStatusOnMission.MISSION_VALIDATED_WAITING_FOR_PAYMENT)!
         this.candidatService.getCondidatById(this.candidatApplied.candidatId).subscribe({
         next: (data: any) => {
         this.candidat = data;
       }
       });
        this.form.patchValue({
          candidatFullname: this.candidatApplied?.candidateName ?? this.candidat?.fullname,
          candidatId: this.candidatApplied?.candidatId??this.candidat?.id,
          enddate: this.mission.enddate,
          startdate: this.mission.startdate,
          etablissementId: this.mission.etablissementId,
          serviceAffectation: this.mission.typePoste,
          id: this.mission.id,
          missionStatus: MissionStatusEnum.VALIDATED,
          rating: '',
        })
      }
    })
  }

  sendEvaluation() {
    this.isClosed = true
    this.missionService.sendEval(this.form.value).subscribe({
      next:() => {
        this.flag.displayFlag('Évaluation envoyée avec succès', FlagType.success)
        this.router.navigate([`/agency/details-establishment/${this.mission.etablissementId}`]);
      },
      error: () => {
        this.flag.displayFlag('Erreur ! veuillez contacter l\'administration ', FlagType.error)
        this.isClosed = false
      }
    })
  }

  rating(rating : number, key: string){
    // @ts-ignore
    this[key] = rating;
    const finalRating = (this.punctualityRate + this.connectionClientRate + this.skillsRate + this.connectionMemberRate) / 4
    this.form.get('rating')?.patchValue(finalRating)
  }

  protected readonly calculDiffDays = calculDiffDays;
  protected readonly moment = moment;
}
